import s from "./index2.js";
import { resolveComponent as o, openBlock as n, createElementBlock as u, createVNode as l, createBlock as r, createCommentVNode as t } from "vue";
import "./index3.js";
import m from "../../../../_virtual/index.js";
const d = { class: "header-navigation-container" };
function p(e, f, y, g, C, h) {
  const a = o("Header"), c = o("Navigation"), i = o("RedirectPrompt");
  return n(), u("div", d, [
    l(a, {
      bannerStyle: e.bannerStyle,
      config: e.config,
      csr: e.csr,
      location: e.location,
      user: e.user
    }, null, 8, ["bannerStyle", "config", "csr", "location", "user"]),
    e.config.showNavigation !== !1 ? (n(), r(c, {
      key: 0,
      menuCategories: e.menuCategories,
      showSearch: e.showSearch,
      config: e.config,
      user: e.user,
      bannerStyle: e.bannerStyle
    }, null, 8, ["menuCategories", "showSearch", "config", "user", "bannerStyle"])) : t("", !0),
    e.showIpRedirectPrompt ? (n(), r(i, {
      key: 1,
      currentCountryName: e.location.currentCountry.name,
      currentCountryCode: e.location.currentCountry.countryCode
    }, null, 8, ["currentCountryName", "currentCountryCode"])) : t("", !0)
  ]);
}
const k = /* @__PURE__ */ m(s, [["render", p], ["__scopeId", "data-v-8f6dceda"]]);
export {
  k as default
};
//# sourceMappingURL=index.js.map
